<div class="author-page">
  <!-- Hero: same banner + wave as Stories / Over Blauwtand, with the full author
       identity (photo + name + role + bio + link) inline — no separate card. -->
  <section class="author-hero">
    <div class="author-hero__container">
      @if (author(); as a) {
        <div class="author-hero__inner">
          @if (authorPhotoUrl; as photo) {
            <img
              class="author-photo"
              [src]="photo"
              [alt]="a.name"
              referrerpolicy="no-referrer"
            />
          }
          <div class="hero-copy">
            <h1 class="hero-title">{{ a.name }}</h1>
            @if (a.role) {
              <p class="hero-role">{{ a.role }}</p>
            }
            @if (a.shortBio) {
              <p class="hero-bio">{{ a.shortBio }}</p>
            }
            @if (teamPagePath; as bio) {
              <a class="hero-bio-link" [routerLink]="bio">
                <span>Lees meer over {{ a.name }}</span>
                <icon name="navigate_next" class="hero-bio-link__icon"></icon>
              </a>
            }
          </div>
        </div>
      } @else if (notFound()) {
        <div class="hero-copy">
          <h1 class="hero-title">Auteur niet gevonden</h1>
        </div>
      } @else {
        <!-- Loading skeleton (light shimmer on the dark hero) -->
        <div class="author-hero__inner" aria-hidden="true">
          <div class="hero-skeleton hero-skeleton--photo"></div>
          <div class="hero-copy">
            <div class="hero-skeleton hero-skeleton--name"></div>
            <div class="hero-skeleton hero-skeleton--role"></div>
            <div class="hero-skeleton hero-skeleton--bio"></div>
            <div class="hero-skeleton hero-skeleton--bio hero-skeleton--bio-short"></div>
          </div>
        </div>
      }
    </div>

    <!-- Decorative orbs -->
    <svg
      class="hero-orb orb-a"
      viewBox="0 0 400 400"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <radialGradient id="authorOrbA" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6" />
          <stop offset="100%" stop-color="#75b6e7" stop-opacity="0" />
        </radialGradient>
      </defs>
      <circle cx="200" cy="200" r="200" fill="url(#authorOrbA)" />
    </svg>
    <svg
      class="hero-orb orb-b"
      viewBox="0 0 400 400"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <radialGradient id="authorOrbB" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35" />
          <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
        </radialGradient>
      </defs>
      <circle cx="200" cy="200" r="200" fill="url(#authorOrbB)" />
    </svg>

    <!-- Wave separator -->
    <svg
      class="hero-wave"
      viewBox="0 0 1440 120"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z"
      ></path>
    </svg>
  </section>

  <!-- Content (grey background): this author's articles -->
  <div class="author-content-container">
    <div class="author-content">
      @if (notFound()) {
        <div class="author-notfound">
          <p>Deze auteurspagina bestaat niet of is verplaatst.</p>
          <a class="author-bio-link" routerLink="/stories">Naar alle stories</a>
        </div>
      } @else if (isLoading()) {
        <div class="author-grid">
          @for (s of [0, 1, 2]; track s) {
            <app-blog-card-skeleton></app-blog-card-skeleton>
          }
        </div>
      } @else if (author(); as a) {
        <h2 class="author-articles-title">Stories van {{ a.name }}</h2>
        @if (posts().length) {
          <div class="author-grid">
            @for (item of posts(); track item.slug) {
              <app-blog-card [item]="item"></app-blog-card>
            }
            @for (slot of placeholderSlots; track slot) {
              <app-blog-card-skeleton [animated]="false"></app-blog-card-skeleton>
            }
          </div>
        } @else {
          <p class="author-empty">
            {{ a.name }} heeft nog geen stories gepubliceerd.
          </p>
        }
      }
    </div>
  </div>
</div>
